import HttpService from "./http.service";

class ShippingCompanyService {
  list = async () => {
    const shippingCompanyEndpoint = "/shipping-companies?page=0&limit=-1";
    return await HttpService.get(shippingCompanyEndpoint);
  };

  paginate = async (page = 0, limit = 25, sortStr = null, filterStr = null) => {
    const shippingCompanyEndpoint = `/shipping-companies?page=${page}&limit=${limit}${
      sortStr ? sortStr : ""
    }${filterStr ? filterStr : ""}`;
    return await HttpService.get(shippingCompanyEndpoint);
  };

  get = async (id) => {
    const shippingCompanyEndpoint = "/shipping-companies";
    return await HttpService.get(`${shippingCompanyEndpoint}/${id}`);
  };

  create = async (data) => {
    const shippingCompanyEndpoint = "/shipping-companies";
    return await HttpService.post(shippingCompanyEndpoint, data);
  };

  toggleStatus = async (id, data) => {
    const shippingCompanyEndpoint = "/shipping-companies/toggle-status";
    return await HttpService.put(`${shippingCompanyEndpoint}/${id}`, data);
  };

  update = async (id, data) => {
    const shippingCompanyEndpoint = "/shipping-companies";
    return await HttpService.put(`${shippingCompanyEndpoint}/${id}`, data);
  };

  delete = async (id) => {
    const shippingCompanyEndpoint = "/shipping-companies";
    return await HttpService.delete(`${shippingCompanyEndpoint}/${id}`);
  };
}

export default new ShippingCompanyService();
